import React, { useEffect, useState } from "react";

import { Row, Col, Card, Table } from "react-bootstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { config } from "./CommonUtils/CommonURLS";
import { CommonAxiosGet } from "./CommonUtils/CommonAxios";
import FinancePyramid from "./assets/ApRusa/FinancePyramid ";
function OveralolProjects({ selectedtab }) {
    const toCr = (value) => +(value / 10000000).toFixed(2);
    const [overallfinanceCount, setOverallfinanceCount] = useState([]);
    function OverAllFinanceCount(selectedtab) {
        if (!selectedtab || selectedtab.trim() === "") {
            console.log("Skipping API call — invalid selectedtab:", selectedtab);
            return;
        }
        let url = `${config.url.API_URL}getOverallFinancialStatus?rusa_phase=${selectedtab}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setOverallfinanceCount(res?.data?.FinancialStatus);
            } else {
                setOverallfinanceCount([]);
            }
        });
    }



    const [overallPieStatus, setOverallPieStatus] = useState([]);
    function OverAllPieData(selectedtab) {
        let url = `${config.url.API_URL}getOverallProjectStatus?rusa_phase=${selectedtab}`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {

                setOverallPieStatus(res?.data?.ProjectStatus)

            }
            else {
                setOverallPieStatus([]);

            }
        });
    }


    useEffect(() => {
        // GetclgList();
        OverAllPieData(selectedtab);
        OverAllFinanceCount(selectedtab);
        ShowComponent(selectedtab);

    }, [selectedtab]);



    // __________________Clg wise bar graph_________________________

    // component wise line graph logic-----------------
    const [componentdata, setComponentdata] = useState([]);
    function ShowComponent(selectedtab) {
        if (!selectedtab || selectedtab.trim() === "") {
            console.log("Skipping API call — invalid selectedtab:", selectedtab);
            return;
        }
        let url = `${config.url.API_URL}getCmpwiseClgData?rusa_phase=${selectedtab}`;
        CommonAxiosGet(url).then(res => {
            if (res?.data?.scode === "01") {
                setComponentdata(res?.data?.CmpwiseClgData);

            }
            else {
                setComponentdata([]);

            }
        });
    }

    const pieDataprojectstatus = overallPieStatus?.length
        ? [
            { name: "Ongoing", value: overallPieStatus[0]?.ongoing || 0 },
            { name: "Completed", value: overallPieStatus[0]?.completed || 0 },
            { name: "Bills Pending", value: overallPieStatus[0]?.bills_pending || 0 }
        ]
        : [];
    const apiData = overallfinanceCount[0]; // your API response object
    const totalApproved = toCr(apiData?.tot_approve || 0);
    const totalUtilised = toCr(apiData?.tot_utilised || 0);
    const balance = +(totalApproved - totalUtilised).toFixed(2);

    const chartData = pieDataprojectstatus.map(item => ({
        name: item.name,
        y: item.value
    }));

    const overallprojecttotal = chartData.reduce((sum, item) => sum + item.y, 0);

    const overallproject = {
        chart: {
            type: "pie",
            height: 320,
            width: 400,
        },

        title: {
            text: null
        },

        subtitle: {

            align: "right",
            verticalAlign: "middle",
            useHTML: true
        },

        tooltip: {
            pointFormat: "<b>{point.y}</b> projects"
        },
        credits: {
            enabled: false
        },

        accessibility: {
            point: {
                valueSuffix: " projects"
            }
        },

        plotOptions: {
            pie: {
                innerSize: "60%",        // makes it donut
                borderRadius: 6,
                allowPointSelect: true,
                cursor: "pointer",
                dataLabels: {
                    enabled: true,
                    format: "{point.name}: {point.y}",
                    style: {
                        fontSize: "12px"
                    }
                },
                showInLegend: true
            }
        },
        legend: {
            enabled: false
        },


        colors: ["#f97316", "#16a34a", "#a78bfa"], // Ongoing, Completed, Bills Pending

        series: [
            {
                name: "Projects",
                colorByPoint: true,
                data: chartData
            }
        ]
    };

    const chartData_Component = componentdata?.map(item => ({
        componentName: item.comp_name,
        collegeCount: item.college_count,
        amountAllocated: item.amount_allocated,
        amountUtilised: item.amount_utilised,
        balanceAmount: item.balance_amount,
    }));


    // const CustomXAxisTick = ({ x, y, payload }) => {
    //     const max = 12;
    //     const label =
    //         payload.value.length > max
    //             ? payload.value.slice(0, max) + "..."
    //             : payload.value;

    //     return (
    //         <g transform={`translate(${x},${y + 10})`}>
    //             <text
    //                 x={0}
    //                 y={0}
    //                 textAnchor="middle"
    //                 fontSize={12}
    //             >
    //                 {label}
    //             </text>
    //         </g>
    //     );
    // };


    const totals = componentdata?.reduce(
        (acc, item) => {
            if (item.college_count !== null) {
                acc.college_count += Number(item.college_count || 0);
                acc.amount_allocated += Number(item.amount_allocated || 0);
                acc.amount_utilised += Number(item.amount_utilised || 0);
                acc.balance_amount += Number(item.balance_amount || 0);
            }
            return acc;
        },
        {
            college_count: 0,
            amount_allocated: 0,
            amount_utilised: 0,
            balance_amount: 0,
        }
    );

    const Curveoptions = {
        chart: {
            type: "areaspline",
            height: 360,
        },

        title: {
            text: null,
        },

        xAxis: {
            categories: chartData_Component?.map(item => item?.componentName),
            labels: {
                // rotation: 0,
                rotation: -10,
                style: {
                    fontSize: "11px",
                    whiteSpace: "normal",
                }
            }
        },

        yAxis: {
            title: {
                text: null,
            },
            allowDecimals: false,
        },

        tooltip: {
            useHTML: true,
            formatter: function () {
                /* eslint-disable react/no-this-in-sfc */

                const point = chartData_Component[this.point.index]; // NOSONAR - Highcharts formatter requires 'this' context
                /* eslint-enable react/no-this-in-sfc */

                return `
                <b>${point?.componentName}</b><br/>
                Colleges: <b>${point?.collegeCount}</b><br/>
                Allocated: ₹${point?.amountAllocated}<br/>
                Utilised: ₹${point?.amountUtilised}<br/>
                Balance: ₹${point?.balanceAmount}
            `;
            }
        },

        plotOptions: {
            series: {
                marker: {
                    enabled: true,
                    radius: 5,
                },
                dataLabels: {
                    enabled: true,
                }
            }
        },

        series: [
            {
                name: "Count",
                data: chartData_Component.map(item => item.collegeCount),
                color: "#42c7d6",
                fillColor: {
                    linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                    stops: [
                        [0, "rgba(66,199,214,0.4)"],
                        [1, "rgba(66,199,214,0.05)"]
                    ]
                }
            }
        ],

        credits: {
            enabled: false,
        }
    };
    return (
        <>
            <Row>



                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-4'>
                    <div className='overal-stathead'>
                        <span>  Financial Overview of Total Institutions</span>
                    </div>
                    <Card className='oeveral-statcard oeveral-statcard2 py-0'>
                        <div
                            className='project-statdiv-two'>

                            <FinancePyramid
                                totalApproved={totalApproved}
                                totalUtilised={totalUtilised}
                                balance={balance}
                            />

                        </div>


                    </Card>

                </Col>



                <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-4'>
                    <div className='overal-stathead'>
                        <span>Overall Project Status Till Now</span>
                    </div>
                    <Card className='oeveral-statcard oeveral-statcard1 py-0'>
                        <div className='project-statdiv-one'>

                            <div className="piechart-one-overal">

                                <div className="d-block d-xl-flex " style={{ alignItems: "center" }}>

                                    {/* Chart */}
                                    <div style={{ flex: 1 }}>
                                        <HighchartsReact
                                            highcharts={Highcharts}
                                            options={overallproject}
                                        />
                                    </div>

                                    {/* Total Projects */}
                                    <div style={{ paddingLeft: 20 }}>
                                        <div style={{ fontSize: 16, fontWeight: 700, color: "red" }}>
                                            Total Projects: {overallprojecttotal}
                                        </div>

                                        <div style={{ marginTop: 10 }}>
                                            {chartData?.map((item, index) => (
                                                <div
                                                    key={index}
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        marginBottom: 8
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            width: 10,
                                                            height: 10,
                                                            borderRadius: "50%",
                                                            backgroundColor: overallproject.colors[index],
                                                            marginRight: 8,
                                                            flexShrink: 0
                                                        }}
                                                    />

                                                    {/* ✅ Prevent wrapping */}
                                                    <span
                                                        style={{
                                                            fontSize: 14,
                                                            whiteSpace: "nowrap"
                                                        }}
                                                    >
                                                        {item.name} ({item.y})
                                                    </span>
                                                </div>
                                            ))}

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Row>

                {/* <Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}> */}
                {/* <div className='oeveral-statcard'>
                        <div className='aff-tablediv table-responsive' style={{ height: "360px" }}>
                            <Table className='table table-hover table-bordered mb-0 table-striped affl-table'>
                                <thead>
                                    <tr>
                                        <th>Component</th>
                                        <th>No.of. <br />Institutions</th>
                                        <th> Amount Allocated  </th>
                                        <th> Amount Utilised </th>
                                        <th> Remaining Amount  </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {componentdata?.map((item, index) => (
                                        <tr key={index}>
                                            {item.college_count !== null ? (
                                                <>
                                                    <td>{item.comp_name}</td>
                                                    <td style={{ textAlign: "right" }}>{item.college_count}</td>
                                                    <td>{item.amount_allocated}</td>
                                                    <td>{item.amount_utilised}</td>
                                                    <td>{item.balance_amount}</td>

                                                </>
                                            ) : (
                                                <td colSpan={2}>{item.comp_name}</td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>


                            </Table>
                        </div>
                    </div> */}


                {/* </Col> */}



                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='mb-4'>


                    <Card className='oeveral-statcard'>
                        <div className='overal-stathead'>
                            <span>  Financial Overview of Components</span>
                        </div>

                        <div className="table-responsive">
                            <Table className='table table-hover table-bordered mb-0 table-striped affl-table'>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Component</th>
                                        <th>No.of. <br />Institutions</th>
                                        <th>Amount Allocated</th>
                                        <th>Amount Utilised</th>
                                        <th>Remaining Amount</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {componentdata?.map((item, index) => (
                                        <tr key={index}>
                                            {item.college_count !== null ? (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.comp_name}</td>
                                                    <td>{item?.college_count}</td>
                                                    <td>{item?.amount_allocated}</td>
                                                    <td>{item?.amount_utilised}</td>
                                                    <td>{item?.balance_amount}</td>
                                                </>
                                            ) : (
                                                <td colSpan={2}>{item?.comp_name}</td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>

                                {/* ✅ FOOTER TOTAL */}
                                <tfoot>
                                    <tr style={{ fontWeight: "bold", background: "#f5f5f5" }}>
                                        <td colSpan={2} style={{ textAlign: "right" }}>
                                            Total
                                        </td>
                                        <td>{totals?.college_count}</td>
                                        <td>{totals?.amount_allocated}</td>
                                        <td>{totals?.amount_utilised}</td>
                                        <td>{totals?.balance_amount}</td>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>
                        <div className="project-statdiv pt-5">
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={Curveoptions}
                            />
                        </div>
                    </Card>
                </Col>


            </Row>




        </>
    );
}

export default OveralolProjects;
